const GOOGLE_FONT_HANDLES: Record<string, string> = {
  inter: 'Inter',
  roboto: 'Roboto',
  nimbus: 'Nimbus+Sans',
  'nimbus sans': 'Nimbus+Sans',
  manrope: 'Manrope',
  'dm sans': 'DM+Sans',
  'plus jakarta sans': 'Plus+Jakarta+Sans',
  sora: 'Sora',
  outfit: 'Outfit',
  'ibm plex sans': 'IBM+Plex+Sans',
  nunito: 'Nunito',
  'nunito sans': 'Nunito+Sans',
  sen: 'Sen',
  'albert sans': 'Albert+Sans',
  lora: 'Lora',
  'source serif 4': 'Source+Serif+4',
  fraunces: 'Fraunces',
  montserrat: 'Montserrat',
  'be vietnam pro': 'Be+Vietnam+Pro'
};

function normaliseFont(font?: string): string {
  return (font ?? '').trim().toLowerCase();
}

function buildGoogleHref(fonts: string[]): string | null {
  const handles = Array.from(
    new Set(
      fonts
        .map((font) => normaliseFont(font))
        .filter((font) => !!font)
        .map((font) => GOOGLE_FONT_HANDLES[font])
        .filter(Boolean)
    )
  );

  if (handles.length === 0) return null;

  const query = handles.map((handle) => `family=${handle}:wght@400;500;600;700`).join('&');
  return `https://fonts.googleapis.com/css2?${query}&display=swap`;
}

export function syncConnectGoogleFonts(fonts: string[], linkId = 'connect-google-fonts') {
  if (typeof document === 'undefined') return;

  const href = buildGoogleHref(fonts);
  const existing = document.getElementById(linkId) as HTMLLinkElement | null;

  if (!href) {
    if (existing) existing.remove();
    return;
  }

  if (existing) {
    if (existing.href !== href) existing.href = href;
    return;
  }

  const link = document.createElement('link');
  link.id = linkId;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

export function clearConnectGoogleFonts(linkId = 'connect-google-fonts') {
  if (typeof document === 'undefined') return;
  const existing = document.getElementById(linkId);
  if (existing) existing.remove();
}
